import axios, { AxiosResponse } from "axios";
import { StorageKey } from "domain/Utils";
import { useAuthenticator } from "hooks/useAuthenticator";
import { useClientRules } from "hooks/useClientRules";
import { useDateStorageCache } from "hooks/useDateStorageCache";
import Environment from "utils/environment";

export const requester = Object.freeze(() => {
	return { axios, onMaintenance: () => { } };
})();

export const useRequest = (url: string) => {
	const auth = useAuthenticator();
	const { getDateItem } = useDateStorageCache();
	const { contextViews } = useClientRules();

	const hasContext = () =>
		contextViews.some((c) => location.href.includes(c));

	const Request = (extraHeaders?: Record<string, string>) => {
		const token = auth.token();

		const headers: Record<string, string> = {
			language:
				localStorage.getItem(StorageKey.SBLanguage) ||
				navigator.language,
			...(extraHeaders || {}),
		};

		if (hasContext()) {
			const contextDate = getDateItem();

			if (contextDate) {
				headers.contextDate = contextDate;
			}
		}

		if (token) {
			headers.Authorization = "Bearer " + token;
		}

		return requester.axios.create({
			baseURL: Environment.API + url,
			headers,
		});
	};

	const OnGeneralError = async <T,>(promise: Promise<T>) => {
		return await new Promise<AxiosResponse>(async (res, rej) => {
			promise
				.then((c: any) => {
					res(c);
				})
				.catch((e) => {
					if (e.response && e.response.status === 401) {
						auth.logout();
						location.href = "/";
					} else if (e.response && e.response.status === 423) {
						requester.onMaintenance();
					} else {
						rej(e);
					}
				});
		});
	};

	return {
		GET: async (url: string, headers?: Record<string, string>) => {
			return await OnGeneralError(Request(headers).get(url));
		},
		POST: async (url: string, value: {}, headers?: Record<string, string>) => {
			return await OnGeneralError(Request(headers).post(url, value));
		},
		PUT: async (url = "", value = {}, headers?: Record<string, string>) => {
			return await OnGeneralError(Request(headers).put(url, value));
		},
		DELETE: async (url = "", headers?: Record<string, string>) => {
			return await OnGeneralError(Request(headers).delete(url));
		},
	};
};